<div class="advance-calendar-container advance-calendar-container--date-range-picker">

  <div class="calendar-module-container datepicker-calendar-wrapper">
    <div class="calendar-module calendar-module--tertiary">
      <div class="calendar-module__data">
        <div class="chips chips--call-mon-v2">
          <i class="fa-light fa-calendar chips__icon"></i>
          <span class="chips__value">
            {{ dateLabel }}
          </span>
        </div>
      </div>
    </div>
    <input type="text" #drp ngxDaterangepickerMd [minDate]="minDate" [(ngModel)]="selectedDate" [locale]="locale"
           [timePicker]="isTimePicker" [timePicker24Hour]="timePicker24Hour" [isMinPicker]="isMinPicker"
           [showCustomRangeLabel]="!isSinglePicker" [keepCalendarOpeningWithRange]="!isSinglePicker"
           [alwaysShowCalendars]="true" [showRanges]="showRanges" [singleDatePicker]="isSinglePicker" [linkedCalendars]="!isSinglePicker"
           [showCancel]="true" [ranges]="!isSinglePicker ? ranges : null" opens="left"
           (datesUpdated)="dateUpdated($event)" class="datepicker-calendar-input" />
  </div>
</div>
